import UploadPaymentField from "./UploadPaymentField"

export default UploadPaymentField
